<template>
  <div class="discount_tag">
    <svg width="100%" height="100%" viewBox="0 0 90 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>discount_tag</title>
        <g id="BrowsingRecordDiscountTag" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="discount_tag_pc" transform="translate(-821.000000, -133.000000)">
                <g id="discount_tag" transform="translate(821.000000, 133.000000)">
                    <path d="M6,0 L69.7205067,0 C70.7976678,-8.11918582e-16 71.8293033,0.434435138 72.5819698,1.20499928 L87.3709529,16.3456499 C88.8482334,17.8580586 88.8934638,20.2589125 87.4741969,21.8258902 L72.5957834,38.2527806 C71.8375097,39.089972 70.7606199,39.567541 69.6310764,39.567541 L5.95041322,39.567541 L5.95041322,39.567541 C2.66409074,39.567541 1.10223802e-14,42.2316317 0,45.5179542 L0,45.54 L0,45.54 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z" id="discount_tag_rectangle" :fill="discount_label_color" transform="translate(45.000000, 22.770000) scale(-1, 1) translate(-45.000000, -22.770000) "></path>
                    <path d="M3.0213889,2.23140496 L65.4122636,2.23140496 C66.4868595,2.23140496 67.5162611,2.66377954 68.268555,3.43111931 L82.9880257,18.4449794 C83.3590406,18.8234146 83.3703874,19.4255796 83.0138929,19.8177236 L68.2826452,36.0220961 C67.5245564,36.8559937 66.4498648,37.331405 65.3228849,37.331405 L3.0213889,37.331405 L3.0213889,37.331405" id="discount_tag_copyrectangle" stroke="#FFFFFF" stroke-linecap="round" transform="translate(43.335179, 19.781405) scale(-1, 1) translate(-43.335179, -19.781405) "></path>
                </g>
            </g>
        </g>
    </svg>
    <div class="discount_tag__text">
      <span>- {{saleValue}}%</span>
    </div>
  </div>
</template>

<script>
export default {
  props:['variants','discount_label_color'],
  computed: {
    saleValue() {
      let { price, regular_price } = this.variants;
      if (isNaN(price) || isNaN(regular_price)) return false;
      let percent = 1 - price / regular_price;
      return Math.round(percent * 100);
    },
  },
}
</script>

<style scoped lang='scss'>
.discount_tag{
  width: 33%;
  position: absolute;
  top: 8.5%;
  color: #fff;
  left: auto;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &__text{
    font-family: 'PingFangSC-Medium';
    position: absolute;
    font-size: 16px;
    padding-left: 10%;
    padding-bottom: 8%;

  }
}
@media screen and(max-width:768px) {
  .discount_tag{
    width: 33%;
    top: 7px !important;
    &__text{
      font-size: 12px;
      padding-left: 10%;
      padding-bottom: 8%;
    }
  }
}
</style>